import React, {useEffect, useState} from "react";
import DataTable from "../../../components/data-table";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import {
    get_all_employee_form
} from '../../../redux/forms';
import Button from "../../../components/button";
import LoadingSpinner from "../../../components/loading-spinner";
import SelectInput from "../../../components/select";
import Modal from "../../../components/modal";
import {clear_employee, get_report_form_employee, GET_REPORT_FORM_EMPLOYEE} from "../../../redux/employees";
import {ToastContainer, toast} from 'react-toastify';

const EmployeesForms = (props) => {
    let dispatch = useDispatch();
    let history = useHistory();

    const _get_all_employee_form = useSelector((state) => state.form_module._get_all_employee_form);
    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const [data, setData] = useState([]);

    useEffect(() => {
        dispatch(get_all_employee_form(token));
    }, [token, dispatch]);

    useEffect(() => {
        if (_get_all_employee_form && _get_all_employee_form.data && _get_all_employee_form.data.datos) {
            setData(_get_all_employee_form.data.datos);
        }
    }, [_get_all_employee_form]);

    const [permisos, setPermisos] = useState([]);
    const [actions, setActions] = useState([]);
    const [modal, setModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [year, setYear] = useState(0);
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 6 }, (_, i) => currentYear - 5 + i);

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
    }, [props]);


    useEffect(() => {
        let act = []
        if (permisos) {
            if (permisos.filter(x => x.codigo === 'view_forms').length > 0) {
                act.push({
                    name: "view",
                    label: "Ver",
                    icon: "bx bx-show",
                    color: "primary",
                    onClick: (item) => {
                        history.push(`/empleado/datos/${item.id}`);
                    },
                })
            }
        }
        setActions(act);
        // eslint-disable-next-line
    }, [permisos, history]);

    const _get_report_form_employee = useSelector((store) => store.employees_module._get_report_form_employee);

    useEffect(() => {
        if (_get_report_form_employee.status === 200) {
            toast.success(_get_report_form_employee.data.mensaje);
            dispatch(clear_employee(GET_REPORT_FORM_EMPLOYEE));
            setModal(false);
            setIsLoading(false);
        } else if (_get_report_form_employee.status !== 0) {
            toast.error(_get_report_form_employee.message);
            dispatch(clear_employee(GET_REPORT_FORM_EMPLOYEE));
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_get_report_form_employee]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);

        if (year === 0) {
            toast.error("Debe seleccionar un año", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }

        dispatch(get_report_form_employee(token, {anio: year}));
    }

    return (
        <div className="app-content content">
            <div className="content-overlay"/>
            <ToastContainer/>
            {isLoading && <LoadingSpinner/>}
            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Formulario empleados"
                            items={[{label: "Verificación de datos", link: "/empleados-formularios"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                { permisos && permisos.filter(x => x.codigo === 'generate_report_form_employee').length > 0 &&
                                    <div className="row">
                                        <div className="col-12 text-right">
                                            <Button
                                                text="Exportar"
                                                theme="success"
                                                type="button"
                                                classes="btn-lg round"
                                                onClick={() => {
                                                    setYear(0);
                                                    document.getElementById("anio").selectedIndex = 0;
                                                    setModal(true);
                                                }}
                                            />
                                        </div>
                                    </div>
                                }
                                <div className="table-responsive">
                                    <DataTable
                                        dataTable={data}
                                        columns={[
                                            {
                                                name: "empleado",
                                                label: "Empleado",
                                                type: "text",
                                            },
                                            {
                                                name: "ruc",
                                                label: "Ruc",
                                                type: "text",
                                            },
                                            {
                                                name: "fecha",
                                                label: "Fecha de actualización",
                                                type: "text",
                                            },
                                            {
                                                name: "estado",
                                                label: "Estado",
                                                type: "text",
                                            },
                                        ]}
                                        actions={actions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main" show={modal}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5>Formuario de empleados</h5>
                    </div>
                    <div className="modal-body p-2">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Año</label>
                                <SelectInput
                                    id="anio"
                                    label="año"
                                    name="anio"
                                    onChange={(e) => setYear(e.target.value)}
                                    options={years ? years.map((item) => ({
                                        name: item,
                                        id: item,
                                    })) : []}
                                />
                            </div>
                            <div className="text-center">
                                <button type="button" className="btn btn-outline-dark" onClick={() => {
                                    setModal(false);
                                }}> Cancelar
                                </button>
                                <Button type="submit" text="Generar reporte" theme="btn btn-success" classes="m-1"
                                        disabled={isLoading}/>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default EmployeesForms;
